import { Switch } from "antd";
import moment from "moment";
import { EditFilled } from "@ant-design/icons";
import { DeleteFilled } from "@ant-design/icons";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useEffect, useState } from "react";
import { useLoaderProvider } from "../../context/LoaderProvider";
import { deleteData, putData } from "../../utils";
import { useNotification } from "../../context/NotificationProvider";
import { errorMsg } from "../../utils/errorMsg";
import AddDiscountCodes from "../../Modal/AddDiscountCodes";
import AddInstitutes from "../../Modal/AddInstitutes";

const TableRows = ({ rows = null, callback = () => {} }) => {
  const [confirm, setConfirm] = useState(false);
  const { updateLoader } = useLoaderProvider();
  const { openNotification } = useNotification();
  const [statuses, setStatuses] = useState(false);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (rows !== null) {
      setStatuses(rows.status);
    }
  }, [rows]);

  const deleteConfirm = async () => {
    updateLoader(true);
    try {
      let res = await deleteData(`/v1/admin/institution/delete/${rows.id}`, {}, true);
      openNotification(res.message);
      setConfirm(false);
      callback();
    } catch (e) {
      let d = errorMsg(e);
      openNotification(d.message);
      callback();
    }
    updateLoader(false);
  };

  const updateStatus = async (s) => {
    updateLoader(true);
    try {
      let res = await putData(
        `/v1/admin/institution/update-status/${rows.id}`,
        {
          status: s,
        },
        true
      );
      openNotification(res.message);
      setStatuses(!statuses);
    } catch (e) {
      let d = errorMsg(e);
      openNotification(d.message);
    }
    updateLoader(false);
  };

  return (
    <>
      <ConfirmationModal
        isOpen={confirm}
        ConfirmationHeading={"Delete"}
        ConfirmationParagraph={"Are you sure, you want to delete this institution?"}
        onCancel={() => {
          setConfirm(false);
        }}
        onOk={deleteConfirm}
      />
      <tr className="bg-white border-b" style={rows.is_deleted ? { backgroundColor: "#f1f1f1" } : null}>
        <th scope="row" className="px-3 py-4 font-medium text-gray-900">
          {rows?.name}
        </th>
        <td className="px-3 py-4 vertical-top">{rows.domain}</td>
        <td className="px-3 py-4 vertical-top">{moment(rows.updated_at).format("DD/MM/YYYY")}</td>
        <td className="px-3 py-4 vertical-top">
          <Switch defaultChecked={statuses} checked={statuses} onChange={updateStatus} />
        </td>
        <td>{rows?.usage_number} users</td>
        <td className="px-3 py-4 vertical-top cursor-pointer flex gap-3">
          <EditFilled onClick={() => setEdit(true)} />
          <DeleteFilled onClick={() => setConfirm(true)} />
        </td>
      </tr>

      {edit ? (
        <AddInstitutes
          editId={rows.id}
          callback={() => {
            callback();
            setEdit(false);
          }}
          isOpen={true}
          onCancel={() => setEdit(false)}
        />
      ) : null}
    </>
  );
};

export default TableRows;
